import { render, staticRenderFns } from "./GoogleAuthorization.vue?vue&type=template&id=407ac41b&"
import script from "./GoogleAuthorization.vue?vue&type=script&lang=js&"
export * from "./GoogleAuthorization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports